import React from 'react';

const Categories = () => (
  <div className="App">
    <h2>Under construction</h2>
  </div>
);

export default Categories;
